module.exports = __webpack_public_path__ + "img/ac2.36e3da59.svg";